module.exports = __webpack_public_path__ + "static/media/yafa_5.99047305.jpg";